"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var LocationResource = /** @class */ (function (_super) {
    tslib_1.__extends(LocationResource, _super);
    function LocationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationResource.endpoint = '/locations';
    LocationResource.MODEL_NAME = 'location';
    return LocationResource;
}(base_1.default));
exports.default = LocationResource;
//# sourceMappingURL=location.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/location.js
// module id = MYwN
// module chunks = 0